import { createFileRoute, redirect } from '@tanstack/react-router'

/** /admin lands on Today, which is the screen he opens most. */
export const Route = createFileRoute('/_authed/_admin/admin/')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/today' })
  },
})
